import type { ReportStatus } from '@/types/report';

export const REPORT_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  REVIEWED: 'REVIEWED',
  COMMENTED: 'COMMENTED',
} as const satisfies Record<string, ReportStatus>;

export const REPORT_STATUS_LABELS: Record<ReportStatus, string> = {
  DRAFT: '草稿',
  SUBMITTED: '已提交',
  REVIEWED: '已读',
  COMMENTED: '已评论',
};

export const REPORT_STATUS_OPTIONS = Object.entries(REPORT_STATUS_LABELS).map(
  ([value, label]) => ({ value, label }),
);

export const REPORT_IMAGE_MAX_COUNT = 9;
export const REPORT_IMAGE_MAX_SIZE_MB = 10;
export const REPORT_SUBMIT_DEADLINE_HOUR = 22;
